import { render, staticRenderFns } from "./EnviosTinyList.vue?vue&type=template&id=76c47648&"
import script from "./EnviosTinyList.vue?vue&type=script&lang=js&"
export * from "./EnviosTinyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports